// 校验 input 输入框，只能输入数字

function checkIntegerOnly(el, binding) {
  el.addEventListener("input", (event) => {
    const value = event.target.value;
    event.target.value = value.replace(/\D/g, ""); // 只保留数字
  });
}

export default {
  // 在绑定元素的父组件被挂载之后调用
  mounted(el, binding) {
    checkIntegerOnly(el, binding);
  },
};
